import { Component, OnInit, TemplateRef, ViewChild, NgZone, Input, SimpleChanges, Output, EventEmitter, OnChanges, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { GoogleMapsService } from "src/app/google-maps.service";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { SharedService } from "src/app/shareModule/services/shared.service";

declare const google: any;

@Component({
  selector: "app-google-map",
  templateUrl: "./google-map.component.html",
  styleUrls: ["./google-map.component.scss"],
})
export class GoogleMapComponent implements OnInit, OnChanges, OnDestroy {
  @Input() params: {
    productsToCompare: [],
    search: "";
    postalCode: any;
    radius: 0;
    latLong: any;
    products: any;
    subCategoriesBasedOnKeyWords: any;
    subcats: []
    fetchedFaqs: []
  } | null = null;
  @Input() productsByLocation: any = [];
  @Input() withOption: boolean | null = true;

  public searchSuggestions = [];
  public getSearchSuggestions(event) {

    const isAscii = event.key?.length === 1  //called for backspace and stuff so not reliable

    const term = event.target.value
    if ((term.length + (isAscii ? 1 : 0)) < 3) {
      this.searchSuggestions = []
      return
    }
    this.auth.getSearchSuggestions(term + (isAscii ? event.key : ''))
      .subscribe({
        next: (data) => {
          this.searchSuggestions = (data.body ?? []).slice(0, 4);
          this.changeDetectorRef.detectChanges();
          console.log(this.searchSuggestions)
        },
        error: console.error
      })
  }
  public openSuggestionText(text) {
    this.searchSuggestions = []
    this.params.search = text
    this.geocodePostalCode();
  }


  @Output()
  public view = new EventEmitter()

  @Output()
  public paramChange = new EventEmitter();

  title = "My Angular Google Maps App";
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = "";
  address: string = "";
  maps: any = {
    postalCode: "",
  };
  showMap: boolean = false;
  screenWidth: number = window.innerWidth; // Added screenWidth
  purpleIcon = {
    url:
      "data:image/svg+xml;charset=UTF-8," +
      encodeURIComponent(`
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="#d945cc" stroke="#000000" stroke-width="1" d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5 14.5 7.6 14.5 9 13.4 11.5 12 11.5z"/>
            </svg>
        `),
    scaledSize: new google.maps.Size(24, 24), // size of the icon
  };
  greenIcon = {
    url:
      "data:image/svg+xml;charset=UTF-8," +
      encodeURIComponent(`
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="#1de7a7" stroke="#000000" stroke-width="1" d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5 14.5 7.6 14.5 9 13.4 11.5 12 11.5z"/>
            </svg>
        `),
    scaledSize: new google.maps.Size(24, 24), // size of the icon
  };
  markers: any = [];

  constructor(private auth: AuthServiceService,
    private ngZone: NgZone, private sharedService: SharedService,
    private _customerService: CustomerService, private toastr: ToastrService,
    private local: LocalServiceService, private googleMapsService: GoogleMapsService,
    private changeDetectorRef: ChangeDetectorRef) {
    console.log("created")
  }
  ngOnDestroy(): void {
    console.log('[Start Destroy] Google Map')
    this.local.clearTimeout(this.timeout1)
    this.googleMapsService.removeCurrentMap();
  }

  ngOnInit(): void {
    console.log("inited")
    this.initMap();
    this.geocodePostalCode();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('change', changes)

    if (changes['params']) {
      this.initMap();
    }
  }

  initMap(): void {
    // this.map = new google.maps.Map(document.getElementById("map"), {
    //   center: { lat: this.lat, lng: this.lng },
    //   zoom: this.distanceToZoom.get(this.params.radius.toString()) ?? 12,
    //   restriction: {
    //     latLngBounds: {
    //       north: 1.47,
    //       south: 1.22,
    //       east: 104.05,
    //       west: 103.62
    //     },
    //     strictBounds: true
    //   }
    // });

    // this.geocoder = new google.maps.Geocoder();

    // this.map.addListener("click", (event: any) => {
    //   //this.removeAllMarkers();
    //   this.marker = undefined;
    //   this.placeMarkerAndPanTo(event.latLng);
    // });
    // this.handleZoom();
    // this.googleMapsService.initMap(this.params.products, 'map')
    //console.trace('initMap')
  }

  // placeMarkerAndPanTo(latLng: any): void {
  //   if (this.marker) {
  //     this.marker.setPosition(latLng);
  //   } else {
  //     this.marker = new google.maps.Marker({
  //       position: latLng,
  //       map: this.map,
  //     });
  //   }

  //   this.markers.push(this.marker);
  //   this.map.panTo(latLng);
  //   this.geocodeLatLng(latLng);
  // }
  /**************************** code related to subcategory keywordsd *************************************/

  private _getSubCategoryTypesBasedOnKeyword(keyword: string) {
    console.log('getting sub cats by keyword', keyword)
    this.auth.getSubCategoriesByKeyword(keyword)
      .subscribe({
        next: data => {
          this.params.subCategoriesBasedOnKeyWords = data.body;
          this.paramChange.emit(true);
        },
        error: err => {
          console.error(err);
        }

      })
  }
  /********************************************************************************************************** */
  private loadMoreBadgesOfProduct(list) {
    if (list.otherRatingBadges?.length) {
      return;
    }
    list.otherRatingBadges = [];
    if (list && 'seller_info' in list) {
      try {
        let sellerInfo = list['seller_info'];
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(list['seller_info']);
        }

        if (sellerInfo) {
          if ('superDealRating' in sellerInfo && (sellerInfo.superDealRating || sellerInfo.superDealText)) {
            list.otherRatingBadges.push({
              icon: 'super_deal_1.png',
              name: 'Super Deal',
              rating: sellerInfo.superDealRating,
              text: sellerInfo.superDealText,
            })
          }

          if ('bestPriceRating' in sellerInfo && (sellerInfo.bestPriceRating || sellerInfo.bestPriceText)) {
            list.otherRatingBadges.push({
              icon: 'best_price_1.png',
              name: 'Best Price',
              rating: sellerInfo.bestPriceRating,
              text: sellerInfo.bestPriceText
            })
          }

          if ('highQualityRating' in sellerInfo && (sellerInfo.highQualityRating || sellerInfo.highQualityText)) {
            list.otherRatingBadges.push({
              icon: 'high_quality_1.png',
              name: 'Hight Quality',
              rating: sellerInfo.highQualityRating,
              text: sellerInfo.highQualityText
            })
          }
        }
      } catch (e) {
        console.warn(e)
      }
    }
  }

  @Input()
  public isSearchFromHomepage = false;

  timeout1: any;
  getMemberShop(params: any): void {
    this.ngZone.run(() => {
      this.params.products = [];
      this.params.productsToCompare = []
    });
    let payload = { ...params, ...this.params };
    console.log("payload", payload)

    if (!payload.home && !payload.all && !payload.business) {
      this.ngZone.run(async () => {
        this.params.products = []
        this.params.productsToCompare = []
      })
      return
    }
    payload["basedProduct"] = payload.home ? "home" : payload.business ? "business" : "all";
    payload['limit'] = 1000
    payload['searchByCategoryName'] = this.isSearchFromHomepage;
    if (!this.isSearchFromHomepage) {
      this._getSubCategoryTypesBasedOnKeyword(params['search'])
    }


    console.log("FETCH getMemberShopProductList MAPS")
    this._customerService.getMemberShopProductList(payload).subscribe(async (response: any) => {
      this.params.subCategoriesBasedOnKeyWords = [{ subcategoryTypes: response.body?.fetchedCategory?.subcategoryTypes ?? [] }]
      console.log("BEFORE this.params.subcats", this.params.subcats)
      this.params.subcats = (response.body?.fetchedCategory?.subcats ?? (this.params.subcats ?? []))
      console.log("AFTER this.params.subcats", this.params.subcats)
      this.params.fetchedFaqs = JSON.parse(response.body?.fetchedCategory?.faqInfos ?? '[]')
      console.log({ fq: this.params.fetchedFaqs })

      // this.isSearchFromHomepage = false;

      this.ngZone.run(async () => {

        this.params.products = payload.radius && payload.radius != "All"
          ? this._filterByRadius(response.body.data, payload.radius)
          : response.body.data;
        this.params.productsToCompare = this.params.products.slice(0, 5)

        try { this.params.products.forEach(product => this.loadMoreBadgesOfProduct(product)) } catch (e) {
          console.error(e)
        }
        this.local.clearTimeout(this.timeout1)
        this.timeout1 = setTimeout(() => this.paramChange.emit(true), 500);


        this.initMap();


        await Promise.all(
          this.params?.products?.map((row: any) => {
            // const latLong = JSON.parse(row.latLong ?? "{}");
            // if (latLong?.lat) {
            //   // this.marker = new google.maps.Marker({
            //   //   position: JSON.parse(row.latLong ?? "{}"),
            //   //   map: this.map,
            //   //   icon: this.purpleIcon,
            //   // });
            //   // this.markers.push(this.marker);
            //   // this.marker.addListener('click', ()=>{
            //   //   this.view.emit(row);
            //   // })
            // }
          })
        );
      });
    });
  }

  private _filterByRadius(data: Array<any>, radius) {
    if (data && data.length > 0) {
      return data.filter((row) => {
        let coordinate = JSON.parse(row.latLong);
        if (coordinate?.lat && coordinate?.lng) {
          const result = this._isWithinRadius(coordinate, this.params.latLong, radius);

          return result;
        }
        return false
      });
    }
  }

  private _isWithinRadius(point1, point2, radius) {
    return this.local.isWithinRadius(point1, point2, radius)?.check
  }

  private _deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  public get isOnMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767
  }

  removeAllMarkers() {
    for (const marker of this.markers) {
      marker.setMap(null);
    }
    this.markers = [];
  }

  private distanceToZoom = new Map<any, any>([
    ["0.2", 19],
    ["1", 16],
    ["2", 15],
    ["5", 13],
    ["10", 12],
    ["20", 11],
  ]);

  handleZoom() {
    if (!this.map) {
      return;
    }
    const selectedDistance = this.params.radius; // Replace with your selected distance from the array
    const newZoom = this.distanceToZoom.get(selectedDistance.toString()) ?? 12; // Default to 12 if not found

    this.map.setZoom(newZoom);
  }

  async geocodePostalCode(): Promise<void> {
    if (this.params.radius == 0) this.toastr.error("Please Select The Radius First");
    if (this.params.postalCode == "") this.toastr.error("Please Fill Postal Code");

    if (this.params.radius != 0 && this.params.postalCode != "" && !Number.isNaN(Number(this.params.postalCode))) {

      const latLong = await this.local.getLatLongByPostalCode(this.params.postalCode)
      this.params.latLong = latLong
      this.marker = undefined;
      // this.marker.setMap(null)
      this.removeAllMarkers();
      // this.placeMarkerAndPanTo(latLong);

      this.getMemberShop({
        ...latLong as any,
        radius: this.params.radius,
        search: this.params.search,
      });
      this.handleZoom();
    } else {
      if (this.params?.radius.toString() == "All" || this.params.postalCode == "All") {
        this.getMemberShop({
          ...{},
          radius: "All",
          search: this.params.search,
        });
      } else {
        this.toastr.error("Can't find the location you are looking for");
      }
    }


    // this.geocoder.geocode({ address: this.params.postalCode }, (results: any, status: any) => {
    //   if (status === "OK") {
    //     const location = results[0].geometry.location;
    //     const latLong = { lat: location.lat(), lng: location.lng() };
    //     this.params.latLong = latLong
    //     this.marker = undefined;
    //     // this.marker.setMap(null)
    //     this.removeAllMarkers();
    //     this.placeMarkerAndPanTo(latLong);

    //     this.getMemberShop({
    //       ...latLong,
    //       radius: this.params.radius,
    //       search: this.params.search,
    //     });
    //     this.handleZoom();
    //   } else {
    //     if (this.params?.radius.toString() == "All" || this.params.postalCode == "All") {
    //       this.getMemberShop({
    //         ...{},
    //         radius: "All",
    //         search: this.params.search,
    //       });
    //     } else {
    //       this.toastr.error("Can't find the location you are looking for");
    //     }
    //   }
    // });
  }

  getPostalCode(addressComponents: any[]): string {
    for (let i = 0; i < addressComponents.length; i++) {
      if (addressComponents[i]?.types.includes("postal_code")) {
        return addressComponents[i].long_name;
      }
    }
    return "";
  }

  geocodeLatLng(latLng: any): void {
    this.geocoder.geocode({ location: latLng }, (results: any, status: any) => {
      if (status === "OK") {
        if (results[0]) {
          const addressComponents = results[0].address_components;
          this.address = results[0].formatted_address;
          const postalCode = this.getPostalCode(addressComponents);

          this.ngZone.run(() => {
            this.params.postalCode = postalCode;
          });
        } else {
          this.toastr.error("No results found");
        }
      } else {
        this.toastr.error("Can't find the location you are looking for");
      }
    });
  }
}
